import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

const FETCH_PRODUCT_DETAIL_API = 'EMPLOYEE/FETCH_PRODUCT_DETAIL_API'

const apiCall = enhancedMakeFetchAction(FETCH_PRODUCT_DETAIL_API, ({ id }) => ({
  endpoint: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/products/${id}`,
  method: 'GET'
}))

export default apiCall
